import React, { FC } from 'react'

import { interpolateCertificates } from 'shared/interpolate'
import { Box, Flex } from '@chakra-ui/react'
import { useCertificateTemplateQuery } from './CertificateTemplatesPage.codegen'

const variables = {
  organisation: 'ACME Corp',
  fullName: 'John Doe',
  firstName: 'John',
  lastName: 'Doe',
  firstLastName: 'John Doe',
  email: 'example@example.com',
  title: 'Onboarding Training',
  authorOfSource: 'Alexia Miller',
  awardedDate: '12/24/2020',
  awardedDateLong: 'December 24, 2020',
  expiryDate: '12/24/2020',
  expiryDateLong: 'December 24, 2020'
}

interface IProps {
  templateId: number
}

export const CertificateTemplatePreview: FC<IProps> = ({ templateId }) => {
  const { data } = useCertificateTemplateQuery({
    variables: {
      id: templateId
    }
  })

  const svg = data?.admin?.organisation?.certificateTemplate?.svg
  const template = svg ? interpolateCertificates(svg, variables) : ''

  return (
    <Flex justifyContent="center">
      <Box
        boxShadow={'8px 8px 8px 0 rgba(104,128,139,0.20)'}
        lineHeight={0}
        dangerouslySetInnerHTML={{
          __html: template
        }}
      />
    </Flex>
  )
}
